import { render, staticRenderFns } from "./system_stopped.vue?vue&type=template&id=ca6a3936&"
import script from "./system_stopped.vue?vue&type=script&lang=js&"
export * from "./system_stopped.vue?vue&type=script&lang=js&"
import style0 from "./system_stopped.vue?vue&type=style&index=0&id=ca6a3936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports